import { useMutation, useQuery } from '@tanstack/react-query';
import { zohoClient } from 'src/lib/api';

export const useBusiness = () => {
  const mutationFn = (payload) =>
    zohoClient
      .post('api/v1/whatsapp/sendCompanyRequestToZoho', payload)
      .then((response) => response?.data);
  return useMutation({
    mutationFn,
  });
};

export const useRequestQuotation = () => {
  const mutationFn = (payload) =>
    zohoClient
      .post('api/v1/whatsapp/sendCompanyRequestDetailsToZoho', payload)
      .then((response) => response?.data);
  return useMutation({
    mutationFn,
  });
};

export const useSendContactRequestToZoho = () => {
  const mutationFn = (payload) =>
    zohoClient
      .post('api/v1/whatsapp/sendContactRequestToZoho', payload)
      .then((response) => response?.data);
  return useMutation({
    mutationFn,
  });
};

export const useGetSaudiCityNames = () => {
  const queryFn = () =>
    zohoClient.get('api/v1/whatsapp/getSaudiCityNames').then((response) => response?.data);
  return useQuery({
    queryFn,
    queryKey: ['saudiCityNames'],
  });
};

export const useGetEmployeesList = () => {
  const queryFn = () =>
    zohoClient.get('api/v1/whatsapp/getSupportEmployees').then((response) => response?.data);
  return useQuery({
    queryFn,
    queryKey: ['employeesList'],
  });
};
